/**
 * A11Y Form Observer — WCAG 2.1 AA Compliance
 * FIX-011: Intercetta form iniettati da app Shopify di terze parti
 * e applica dinamicamente aria-label agli input "muti" + stili focus.
 *
 * WCAG References:
 * - 1.1.1 (A): Non-text Content
 * - 1.3.1 (A): Info and Relationships
 * - 3.3.1 (A): Error Identification
 * - 4.1.2 (A): Name, Role, Value
 * - 4.1.3 (AA): Status Messages
 * - 2.4.7 (AA): Focus Visible
 *
 * FIX-02 (05-10-2026): live-region per errori form — role=alert su
 * .invalid-feedback popolati da jQuery Validate + <p id="...-error">
 * di Powerful Form Builder (contact 18120 / career 15334) + aria-live
 * su riepilogo [data-form-error].
 * FIX-02b (05-10-2026): variante career senza id — <p class="help-block error">
 * dentro <small class="messages"> senza id: generazione id univoco +
 * aria-describedby + role=alert su P e SMALL (verdetto Auditor 05-10-2026).
 * FIX-08c (06-10-2026): demote H3→H2 titolo Globo Powerful Form Builder
 * (.globo-formbuilder h3.title.globo-heading, contact 18120) — FIX-10b ha
 * introdotto H1 Contact Us → skip h1→h3 (axe heading-order best-practice).
 * Demote a H2 preservando classi/attributi → sequenza h1→h2 valida.
 * Branch: fix/wcag-compliance
 * Created: 2026-06-11
 */

(function() {
  'use strict';

  /**
   * Verifica se un elemento input ha già un nome accessibile
   * (via <label for="...">, aria-label, aria-labelledby, title, o placeholder).
   */
  function hasAccessibleName(input) {
    // 1. aria-label o aria-labelledby
    if (input.hasAttribute('aria-label') || input.hasAttribute('aria-labelledby')) {
      return true;
    }

    // 2. <label for="..."> associato
    if (input.id) {
      var label = document.querySelector('label[for="' + input.id + '"]');
      if (label && label.textContent.trim() !== '') {
        return true;
      }
    }

    // 3. Wrapped in <label>
    var parentLabel = input.closest('label');
    if (parentLabel && parentLabel.textContent.trim() !== '') {
      return true;
    }

    // 4. title attribute
    if (input.hasAttribute('title') && input.getAttribute('title').trim() !== '') {
      return true;
    }

    // 5. placeholder (acceptable fallback per WCAG, ma non ideale — lo marchiamo)
    if (input.hasAttribute('placeholder') && input.getAttribute('placeholder').trim() !== '') {
      // Placeholder da solo non è sufficiente per WCAG 3.3.2, ma è meglio di niente
      // Applichiamo comunque aria-label per rinforzare
      return false;
    }

    // 6. type="hidden", type="submit" con value, ecc.
    if (input.type === 'hidden' || input.type === 'submit' || input.type === 'button' || input.type === 'reset') {
      return true; // Questi hanno nomi accessibili nativi
    }

    return false;
  }

  /**
   * Genera un aria-label di fallback per un input.
   */
  function generateFallbackLabel(input) {
    var label = '';

    // 1. Prova placeholder
    if (input.hasAttribute('placeholder')) {
      label = input.getAttribute('placeholder').trim();
      if (label) return label;
    }

    // 2. Prova name attribute (umanizzato)
    if (input.name) {
      label = input.name
        .replace(/^customer\[|\]$/g, '')
        .replace(/\[/g, ' ')
        .replace(/\]/g, '')
        .replace(/\[note\]/g, '')
        .replace(/_/g, ' ')
        .replace(/-/g, ' ')
        .replace(/\s+/g, ' ')
        .trim();
      if (label) return label.charAt(0).toUpperCase() + label.slice(1);
    }

    // 3. Prova il testo adiacente (span, div vicini)
    var parent = input.closest('.form-group, .form-floating, .mc-field-group, .field, .input-group');
    if (parent) {
      var textNodes = parent.querySelectorAll('label, span, .label, .field-label');
      for (var i = 0; i < textNodes.length; i++) {
        var text = textNodes[i].textContent.trim();
        if (text && text.length < 100) {
          return text;
        }
      }
    }

    // 4. Fallback basato sul type
    var typeMap = {
      'email': 'Email',
      'tel': 'Phone',
      'number': 'Number',
      'text': 'Text field',
      'password': 'Password',
      'search': 'Search',
      'url': 'URL',
      'date': 'Date'
    };
    return typeMap[input.type] || 'Form field';
  }

  /**
   * Applica aria-label e stili focus a un singolo input.
   */
  function remediateInput(input) {
    // Skip hidden, submit, button, reset
    if (!input || input.nodeName !== 'INPUT' && input.nodeName !== 'TEXTAREA' && input.nodeName !== 'SELECT') {
      return;
    }
    if (input.type === 'hidden' || input.type === 'submit' || input.type === 'button' || input.type === 'reset') {
      return;
    }

    // Se ha già un nome accessibile, verifico solo gli stili focus
    if (hasAccessibleName(input)) {
      ensureFocusStyles(input);
      return;
    }

    // Genera e applica aria-label
    var fallbackLabel = generateFallbackLabel(input);
    if (fallbackLabel) {
      input.setAttribute('aria-label', fallbackLabel);
    }

    // Assicura stili focus visibili
    ensureFocusStyles(input);
  }

  /**
   * Assicura che l'input non abbia outline: none e che erediti
   * gli stili focus del tema (FIX-004, FIX-006).
   */
  function ensureFocusStyles(input) {
    // Aggiunge una classe per il foglio di remediation se non presente
    if (!input.classList.contains('a11y-focus-checked')) {
      input.classList.add('a11y-focus-checked');

      // Se l'input ha inline style con outline:none, lo rimuove
      if (input.style.outline === 'none' || input.style.outline === '0') {
        input.style.outline = '';
      }
    }
  }

  var a11yErrSeq = 0;
  var ERROR_SEL = '.invalid-feedback label.error, .invalid-feedback .error, p[id$="-error"], [id$="-error"], p.help-block.error, p.error, .help-block.error';
  var WRAP_SEL = 'small.messages, .messages';

  function ensureErrId(err) {
    if (err.id) return err.id;
    a11yErrSeq++;
    var base = 'a11y-err-' + a11yErrSeq;
    if (document.getElementById(base)) {
      base = base + '-' + Date.now().toString(36);
    }
    err.id = base;
    return err.id;
  }

  function hasValidDescribedby(field) {
    var db = field.getAttribute('aria-describedby');
    if (!db) return false;
    var ids = db.split(/\s+/);
    for (var v = 0; v < ids.length; v++) {
      if (!ids[v]) continue;
      var t = document.getElementById(ids[v]);
      if (t && ((t.textContent || '').trim() || t.hasAttribute('role'))) return true;
    }
    return false;
  }

  function linkFieldToError(field, errId) {
    if (!field || !errId) return;
    var current = field.getAttribute('aria-describedby') || '';
    var parts = current.split(/\s+/);
    var found = false;
    for (var q = 0; q < parts.length; q++) {
      if (parts[q] === errId) {
        found = true;
        break;
      }
    }
    if (!found) {
      var next = current ? (current + ' ' + errId) : errId;
      field.setAttribute('aria-describedby', next);
    }
    if (!field.hasAttribute('aria-invalid')) {
      field.setAttribute('aria-invalid', 'true');
    }
  }

  function findFieldForError(err, container) {
    var scope = container;
    if (err.closest) {
      scope = err.closest('.form-group, .field, .form-field, .form-row, .wizard__field, .form-item, .input-wrapper') || err.closest('form') || container;
    }
    var candidates = [];
    if (scope && scope.querySelectorAll) {
      var list = scope.querySelectorAll('input:not([type="hidden"]):not([type="submit"]):not([type="button"]):not([type="reset"]), textarea, select');
      for (var c = 0; c < list.length; c++) {
        candidates.push(list[c]);
      }
    }
    if (candidates.length === 0 && container && container.querySelectorAll && scope !== container) {
      var all = container.querySelectorAll('input:not([type="hidden"]):not([type="submit"]):not([type="button"]):not([type="reset"]), textarea, select');
      for (var d = 0; d < all.length; d++) {
        candidates.push(all[d]);
      }
    }
    if (candidates.length === 0) {
      return null;
    }
    if (candidates.length === 1) return candidates[0];
    var i;
    for (i = 0; i < candidates.length; i++) {
      if (candidates[i].getAttribute('aria-invalid') === 'true' && !hasValidDescribedby(candidates[i])) {
        return candidates[i];
      }
    }
    for (i = 0; i < candidates.length; i++) {
      if (!hasValidDescribedby(candidates[i])) {
        return candidates[i];
      }
    }
    return candidates[0] || null;
  }

  function matchesSel(el, sel) {
    if (!el || !el.matches) return false;
    try {
      return el.matches(sel);
    } catch (e) {
      return false;
    }
  }

  function isWrap(el) {
    if (!el) return false;
    if (el.tagName === 'SMALL') return true;
    var c = el.className || '';
    return (typeof c === 'string' && c.indexOf('messages') !== -1);
  }

  /**
   * FIX-02: rende gli errori di validazione annunciabili da screen reader.
   * jQuery Validate inserisce <label class="error"> dentro .invalid-feedback;
   * Powerful Form Builder inserisce <p id="...-error"> (contact 18120) oppure
   * <p class="help-block error"> dentro <small class="messages"> senza id
   * (career 15334). Entrambi diventano live-region assertive (role=alert) +
   * aria-invalid / aria-describedby sul campo.
   * FIX-02b (05-10-2026): estensione a variante career senza id — generazione
   * id univoco + associazione aria-describedby + role=alert su P e SMALL.
   * FIX-02c (05-10-2026): fix self-miss — querySelectorAll non include il
   * container stesso; P iniettato come addedNode veniva saltato (role=null,
   * nessun id, nessun describedby su career). Ora include self + parent.
   */
  function remediateErrorMessages(container) {
    if (!container || !container.querySelectorAll) return;
    var list = [];
    var seen = [];
    function pushUnique(el) {
      if (!el || el.nodeType !== 1) return;
      for (var s = 0; s < seen.length; s++) {
        if (seen[s] === el) return;
      }
      seen.push(el);
      list.push(el);
    }
    if (matchesSel(container, ERROR_SEL) || matchesSel(container, WRAP_SEL) || isWrap(container)) {
      pushUnique(container);
    }
    var found = container.querySelectorAll(ERROR_SEL + ', ' + WRAP_SEL);
    for (var fi = 0; fi < found.length; fi++) {
      pushUnique(found[fi]);
    }
    for (var i = 0; i < list.length; i++) {
      var err = list[i];
      var txt = (err.textContent || '').trim();
      var wrap = isWrap(err);
      if (!txt && !wrap && !err.id) continue;
      if (wrap && !txt) {
        if (!err.hasAttribute('role')) {
          err.setAttribute('role', 'alert');
        }
        continue;
      }
      if (!err.hasAttribute('role')) {
        err.setAttribute('role', 'alert');
      }
      var parent = err.parentElement;
      if (parent && isWrap(parent)) {
        if (!parent.hasAttribute('role')) {
          parent.setAttribute('role', 'alert');
        }
      }
      if (txt && !wrap) {
        var errId = ensureErrId(err);
        var linked = findFieldForError(err, container.nodeType === 1 && container.tagName !== 'BODY' && container.closest ? (container.closest('form') || document.body) : document.body);
        if (!linked) {
          linked = findFieldForError(err, document.body);
        }
        if (linked) {
          linkFieldToError(linked, errId);
        }
      }
    }
    var described = container.querySelectorAll('input[aria-describedby], textarea[aria-describedby], select[aria-describedby]');
    for (var j = 0; j < described.length; j++) {
      var field = described[j];
      var ids = (field.getAttribute('aria-describedby') || '').split(/\s+/);
      for (var k = 0; k < ids.length; k++) {
        if (!ids[k]) continue;
        var target = document.getElementById(ids[k]);
        if (target && !target.hasAttribute('role')) {
          target.setAttribute('role', 'alert');
        }
      }
    }
    var invalids = container.querySelectorAll('.is-invalid, .invalid-feedback:not(:empty)');
    for (var m = 0; m < invalids.length; m++) {
      var scope = invalids[m].closest ? (invalids[m].closest('.form-group') || container) : container;
      var fields = scope.querySelectorAll ? scope.querySelectorAll('input, textarea, select') : [];
      for (var n = 0; n < fields.length; n++) {
        if (!fields[n].hasAttribute('aria-invalid')) {
          fields[n].setAttribute('aria-invalid', 'true');
        }
      }
    }
  }

  /**
   * FIX-08c (06-10-2026): demote H3→H2 del titolo iniettato da Globo
   * Powerful Form Builder (.globo-formbuilder h3.title.globo-heading).
   * Contesto: FIX-10b aggiunge H1 Contact Us su template contact → lo H3
   * di Globo crea skip h1→h3 (axe heading-order best-practice, WCAG 1.3.1).
   * Il markup è third-party (app 18120 contact / 15334 career), iniettato
   * async: non editabile in Liquid → demote via DOM preservando classi,
   * attributi, id e innerHTML. Parità visiva 100% (stesse classi CSS).
   * Idempotente via data-a11y-demoted; sicura su ogni pagina (h1→h2→h2
   * resta valida, quindi applicata a qualsiasi .globo-formbuilder).
   */
  function demoteGloboHeading(h3) {
    if (!h3 || h3.tagName !== 'H3') return false;
    if (h3.getAttribute('data-a11y-demoted') === 'h3-to-h2') return false;
    var h2 = document.createElement('h2');
    for (var a = 0; a < h3.attributes.length; a++) {
      var attr = h3.attributes[a];
      h2.setAttribute(attr.name, attr.value);
    }
    h2.innerHTML = h3.innerHTML;
    h2.setAttribute('data-a11y-demoted', 'h3-to-h2');
    h3.parentNode.replaceChild(h2, h3);
    return true;
  }

  function remediateGloboHeadings(container) {
    var root = container && container.querySelectorAll ? container : document;
    var demoted = 0;
    // Selettore primario (verdetto Auditor): h3.title.globo-heading
    // + fallback largo per varianti future del builder.
    var sels = [
      '.globo-formbuilder h3.title.globo-heading',
      '.globo-formbuilder h3.title',
      '.globo-formbuilder h3'
    ];
    var seen = [];
    function already(el) {
      for (var s = 0; s < seen.length; s++) {
        if (seen[s] === el) return true;
      }
      return false;
    }
    // Self-include: il container stesso può essere lo H3 iniettato.
    if (root !== document && root.tagName === 'H3' && root.closest && root.closest('.globo-formbuilder')) {
      if (!already(root) && demoteGloboHeading(root)) demoted++;
      seen.push(root);
    }
    for (var i = 0; i < sels.length; i++) {
      var list;
      try {
        list = root.querySelectorAll(sels[i]);
      } catch (e) {
        continue;
      }
      for (var j = 0; j < list.length; j++) {
        var h3 = list[j];
        if (already(h3)) continue;
        seen.push(h3);
        if (demoteGloboHeading(h3)) demoted++;
      }
      // Se il selettore primario ha già demotato, i fallback trovano 0 nodi.
      if (demoted > 0 && i === 0) break;
    }
    return demoted;
  }

  /**
   * Processa tutti gli input in un container (form o nodo DOM).
   */
  function remediateContainer(container) {
    if (!container) return;

    // Input, textarea, select
    var inputs = container.querySelectorAll('input:not([type="hidden"]):not([type="submit"]):not([type="button"]):not([type="reset"]), textarea, select');
    for (var i = 0; i < inputs.length; i++) {
      remediateInput(inputs[i]);
    }

    // FIX-02: live-region errori
    remediateErrorMessages(container);

    // FIX-08c: demote H3→H2 titolo Globo (iniettato async, serve anche qui
    // per i container già presenti al primo scan)
    try {
      remediateGloboHeadings(container);
    } catch (e) {}
  }

  /**
   * Processa tutti i form già presenti al caricamento.
   */
  function remediateAllForms() {
    var forms = document.querySelectorAll('form');
    for (var i = 0; i < forms.length; i++) {
      remediateContainer(forms[i]);
    }

    // Anche input standalone (es. search bar fuori da form)
    remediateContainer(document.body);

    // FIX-08c: primo passaggio su DOM statico (Globo può essere già presente)
    try {
      var n08c = remediateGloboHeadings(document);
      if (n08c > 0) console.log('[A11Y] FIX-08c: demoted ' + n08c + ' Globo H3→H2.');
    } catch (e) {}

    console.log('[A11Y] Form Observer: ' + document.querySelectorAll('form').length + ' forms scanned. Inputs remediated where needed.');
  }

  /**
   * MutationObserver: intercetta nuovi form iniettati dinamicamente.
   */
  function initObserver() {
    var observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        // FIX-02/02b: errori jQuery Validate / Powerful Form appaiono come
        // cambi di testo/attributi dentro .invalid-feedback, <p id="-error">,
        // p.help-block.error o small.messages (variante career senza id)
        if (mutation.type === 'characterData' || mutation.type === 'attributes') {
          var t = mutation.target.nodeType === Node.ELEMENT_NODE ? mutation.target : mutation.target.parentElement;
          if (t && t.closest && (t.closest('.invalid-feedback') || t.closest('.help-block') || t.closest('.messages') || t.closest('small') || (t.id && /-error$/.test(t.id)))) {
            remediateErrorMessages(document.body);
          }
        }
        // Nuovi nodi aggiunti al DOM
        // FIX-02c: il P.help-block.error iniettato come addedNode veniva
        // saltato (querySelectorAll non include self) — remediate diretto.
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === Node.ELEMENT_NODE) {
            // FIX-08c: Globo inietta .globo-formbuilder + h3.title async —
            // demote immediato (self-include gestisce H3 come addedNode).
            try {
              if ((node.classList && node.classList.contains('globo-formbuilder')) || (node.querySelectorAll && (node.querySelector('.globo-formbuilder') || node.querySelector('h3.title'))) || (node.tagName === 'H3' && node.closest && node.closest('.globo-formbuilder'))) {
                remediateGloboHeadings(node);
              }
            } catch (e) {}
            if (matchesSel(node, ERROR_SEL) || matchesSel(node, WRAP_SEL) || isWrap(node)) {
              remediateErrorMessages(node);
            }
            // Se il nodo stesso è un form
            if (node.nodeName === 'FORM' || node.matches === undefined) {
              remediateContainer(node);
            }

            // Se contiene form al suo interno
            if (node.querySelectorAll) {
              var forms = node.querySelectorAll('form');
              for (var i = 0; i < forms.length; i++) {
                remediateContainer(forms[i]);
              }

              // Input standalone aggiunti fuori da form
              var standaloneInputs = node.querySelectorAll('input:not(form input), textarea:not(form textarea), select:not(form select)');
              if (standaloneInputs.length > 0) {
                for (var j = 0; j < standaloneInputs.length; j++) {
                  if (!standaloneInputs[j].closest('form')) {
                    remediateInput(standaloneInputs[j]);
                  }
                }
              }

              // FIX-02: errori iniettati senza form wrapper
              remediateErrorMessages(node);
            }
          }
        });
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['class']
    });

    console.log('[A11Y] Form Observer: MutationObserver attivato. Monitoraggio form plugin in corso...');
  }

  // Avvio: DOM già pronto
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      remediateAllForms();
      initObserver();
    });
  } else {
    // DOM già caricato (es. script in fondo alla pagina)
    remediateAllForms();
    initObserver();
  }

})();
